import { useEffect, useState } from "react";
import { saveAs } from "file-saver";

import image from '../images/image-icon.ico';
import loading from '../images/progress.gif';
import failed from '../images/failed.ico';
import axios from "axios";

const Player = ({imgdata, newtab, thumb}) => {
        
    const [activeImage, setActiveImage] = useState({})
    const [fetchedImage, setFetchedImage] = useState(image)
    const [imagedetails, setImagedetails] = useState({
        "id":0,
        "title":"",
        "short":null,
        "description":"",
        "type":"",
        "date":"",
        "rating":0,
        "public":0,
        "downloads":0,
        "folder":0,
        "source":"",
        "thumb":"",
        "settings":null
    })

    useEffect(() => {
        setActiveImage(imgdata)
        if (newtab) {
            axios.get(`https://nexsu.arina.lol/api/win7/filedetails/${imgdata.win7id}`).then((res, err) => {
                if (err) return console.log(err)
                setImagedetails(res.data[0])
            })
        }
    }, [imgdata])

    useEffect(() => {
        if (activeImage.length < 1) return
        setFetchedImage(loading)
        const getstring = (thumb ? `https://nexsu.arina.lol/api/win7/thumb/${activeImage.source}` : `https://nexsu.arina.lol/api/win7/acfile/${activeImage.source}`)
        axios.get(getstring, {responseType: "arraybuffer"}).then((res) => {
            const base64 = btoa(
                new Uint8Array(res.data).reduce(
                    (data, byte) => data + String.fromCharCode(byte),
                    ''
                )
            )
            setFetchedImage(`data:;base64,${base64}`)
        }).catch((err) => {
            setFetchedImage(failed)
        })
    }, [activeImage])

    const setNewImage = (imgroute, win7id) => {
        sessionStorage.setItem('fileroute', imgroute)
        sessionStorage.setItem('win7id', win7id)
        document.getElementById('mediaplayer-open').click()
    }

    const download = (filename) => {
        if (filename === null || filename === "") return
        saveAs(`https://nexsu.arina.lol/api/win7/acfile/${filename}`, `${filename}`)
    }

    const share = (win7id) => {
        navigator.clipboard.writeText(`https://nexsu.net/?marker=${win7id}`)
    }

    return (
        <>
            <div id="details" className="screen media-player-grid" style={{height: 'calc(100% - 14px)', background: 'white', gridColumn: 'span 2'}}>
                <div className="file-top-bar">
                    <div>
                        <button style={{color: 'gray'}}>Files ▾</button>
                        <button style={{color: 'gray'}}>Print ▾</button>
                        <button style={{color: 'gray'}}>E-mail</button>
                        <button style={{color: 'gray'}}>Burn ▾</button>
                        <button style={{color: 'gray'}}>Open ▾</button>
                        <button style={{color: 'black'}} onClick={() => document.getElementById('mediaplayer-exit').click()}>{newtab ? "Close Window" : null}</button>
                    </div>
                    <div>
                        <button><img alt="decor" width={'16px'} height={'16px'} src="/images/bgs/help.ico" /></button>
                    </div>
                </div>
                <div style={{height: '100%', width: '100%', display: 'grid', gridTemplateColumns: '100%', gridTemplateRows: `${newtab ? '50px calc(100% - 50px' : '100%'}`}}>
                    {newtab ?
                        <div style={{width: '100%', background: 'linear-gradient(0deg, #dce6f5 0%, #dce6f5 50%, #edf5fd 50.1%, #edf5fd 100%)', filter: 'brightness(0.8) saturate(5)', borderBottom: 'solid #3a4956 1px', borderRadius: '0 0 4px 4px'}}>
                            <h2 className="player-title">{imagedetails?.title}</h2>
                        </div>
                    :null}
                    <div className="media-display" style={{display: 'grid', gridTemplateColumns: `${(newtab && window.innerWidth > 800) ? '15% 85%' : '100%'}`, gridTemplateRows: '100%'}}>
                        <button className="download" style={{position: 'absolute', right: 0}} title="Download" onClick={() => download(activeImage.source)}>⤓</button>
                        <button className="share" style={{position: 'absolute', right: 0, filter: 'hue-shift(180deg)'}} title="Share (copy embed to clipboard)" onClick={() => share(activeImage.win7id)}>➦</button>
                        {(newtab && window.innerWidth > 800) ?
                            <div style={{width: 'calc(100% - 4px)', padding: '2px', background: 'linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(235, 247, 251) 30%, rgb(246, 251, 255) 60%, rgb(210, 216, 234) 100%)', filter: 'saturate(0)', borderBottom: 'solid #3a4956 1px', borderRadius: '0 4px 4px 0'}}>
                                <h2 className="player-description">{imagedetails?.description}</h2>
                            </div>
                        :null}
                        {!activeImage?.source?.includes(".mp4") ? 
                            <a rel="noreferrer" style={{height: '100%', width: 'calc(100% - 4px)', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '2px'}} 
                            href={newtab ? (activeImage.source !== null ? `/image/${activeImage.source}`: "/images/bgs/welcome.webp") : "#details"} 
                            onClick={() => newtab ? null : setNewImage(activeImage.source, activeImage.win7id)}
                            target={newtab ? "_blank" : "_self"}>
                                <img title="Click to open full image in new tab." className="height-100" style={{cursor: 'pointer', borderRadius: '8px'}} alt={`Failed to fetch thumbnail, click for full image.`} src={fetchedImage} />
                            </a>
                        : 
                            <video className="height-100" style={{minWidth: '100%'}} controls src={`https://nexsu.arina.lol/api/win7/acfile/${activeImage.source}`} />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Player;